import React from "react";
import Reveal from "./Reveal";
import FAQ from "./FAQ";

const SITE_FAQS = [
  {
    q: "What is The Practitioner Method?",
    a: "The Practitioner Method™ is our proprietary three-tier journey (AI Native → AI Builder → AI Leader) built across six pillars and four audiences. Every certification ends in a shippable artifact, not a quiz score.",
  },
  {
    q: "What is the AI Innovation Arena?",
    a: "The AI Innovation Arena is the global championship for AI builders. Spring regional editions run across schools, colleges, and corporates; one global December finale crowns a champion cohort. Winners receive capital, mentorship, and GTM backing.",
  },
  {
    q: "How does AI For Everyone differ from Coursera or upGrad?",
    a: "AI For Everyone is a four-layer ecosystem — Learn, Build, Hire, Invest — not just a course catalogue. We train practitioners, run the Innovation Arena to mentor builders, connect talent to AI roles, and back the founders who emerge. Every layer feeds the next.",
  },
  {
    q: "What certifications does AI For Everyone offer?",
    a: "11 launch certifications across foundations, builder tracks, function-specific applications (Sales, Marketing, HR, Finance, Legal), and leadership (Chief AI Officer). Phase 2 launches Q3 2026 across healthcare, government, manufacturing.",
  },
  {
    q: "How do colleges bring AI For Everyone to their campus?",
    a: "Colleges partner with AI For Everyone to host an Innovation Arena edition on campus, deploy the 17-module flagship programme, and route their top pods into our incubation pathway. Engineering, commerce, and arts undergraduates are all eligible.",
  },
  {
    q: "What does the AI Adoption Services engagement look like?",
    a: "Three service tiers. AI Readiness Audit (2-4 weeks) is a diagnostic that produces a board-ready AI strategy. AI Automation Build (8-16 weeks) deploys working AI systems in production. AI Transformation Partnership (6-12 months) combines audit, build, and workforce training for organizations going all-in on AI.",
  },
  {
    q: "How can my company hire AI talent through AI For Everyone?",
    a: "Three ways. (1) Direct hiring through the AI Jobs marketplace — post AI roles to a pool of certified practitioners with smart matching by skill and tier. (2) Sponsor a regional Innovation Arena edition — get recruiter access to top builders before they enter the open market, plus judging seats at the Global Finale. (3) Build a custom training cohort scoped to your tech stack, with pre-placement assessments and hire-from-cohort rights. Enquire for a custom talent partnership.",
  },
  {
    q: "Why is AI For Everyone positioned as a talent pipeline, not just a training company?",
    a: "Because we don't just teach AI — we certify AI practitioners through The Practitioner Method™, put them through real builds in the AI Innovation Arena, and connect them to companies hiring AI talent. Every learner who completes a certification enters the marketplace by default. Every Arena cohort produces pre-vetted practitioners who have already shipped real AI products. For companies facing the AI talent shortage, we are the supply side of the equation.",
  },
  {
    q: "How does the partner program work?",
    a: "Authorized Partners license the AI For Everyone IP and deliver our certifications in their cities, countries, and continents under a co-branded model. We provide curriculum, trainer certification, marketing support, and continuous updates. Partners run delivery and share revenue.",
  },
  {
    q: "What does pricing look like?",
    a: "Every program is custom-scoped — there is no public price list because no two contexts are the same. School, college, corporate, individual, and Adoption Services engagements all receive a proposal in 48 hours of enquiry.",
  },
];

export default function SiteFAQ() {
  return (
    <section
      id="faq"
      className="py-10 md:py-14 border-t hairline"
      style={{ background: "var(--canvas-deep)" }}
      data-testid="site-faq-section"
    >
      <div className="container-edge">
        <Reveal>
          <p className="section-number">14 — FAQ</p>
        </Reveal>
        <Reveal>
          <h2
            className="mt-6 font-display text-[40px] sm:text-[48px] tracking-tight leading-[1.05]"
            style={{ fontWeight: 400 }}
          >
            Questions, <em className="italic" style={{ fontWeight: 400 }}>answered.</em>
          </h2>
        </Reveal>
        <Reveal delay={120}>
          <FAQ items={SITE_FAQS} testIdPrefix="site-faq" theme="light" />
        </Reveal>
      </div>
    </section>
  );
}
